import { Permission, Res } from 'core/api';
import { Result, SessionProvider } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { PrintFacade, RestaurantFacade } from 'pos/facades';
import { PrintBalanceNextAction } from 'pos/modules/helpers/PrintBalanceNextAction';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		printSystemStatus: () => Promise<Result<PrintBalanceNextAction>>
	}
}

Command.register('printSystemStatus', Preconditions.ensure(Permission.System_PrintStatusReport), async (): Promise<Result<PrintBalanceNextAction>> => {

	if (SessionProvider.isSlave()) {
		await Message.show(Res.Msg.MSG_OPERATION_ONLY_VALID_IN_MASTER_POS());
		return Result.ok(PrintBalanceNextAction.None);
	}

	await PrintFacade.printSystemCloseOut();

	const openedPointsOfSale = (await RestaurantFacade.getPointsOfSaleStatus()).filter(x => !x.IsClosed).length;
	if (openedPointsOfSale > 1)
		return Result.error();

	const result = await Message.confirm(Res.Msg.MSG_CONFIRM_CLOSE_DAY_AFTER_PRINT_BALANCE());
	if (result.ok) {
		return Result.ok(PrintBalanceNextAction.CloseDay);
	}

	return Result.error();
});

